// extracted by mini-css-extract-plugin
module.exports = {"column":"column--1aY93"};